export const blueDarkColor = '#31BFCF';
export const blueLightColor = '#34DEF1';
export const greenLightColor = '#43EC8C';
export const greenDarkColor = '#2BD976';
export const yellowDarkColor = '#DCB555';
export const yellowLightColor = '#FFD15D';
export const darkColor = '#4D4C53';
export const redColor = '#FF6555';
export const redLightColor = '#E96456';
export const redShadowColor = '#F5EEED';